import { gql, useMutation } from '@apollo/client';
import React, { useCallback, useState } from 'react';
import Modal, { ModalBody, ModalFooter } from '../../components/Modal';
import { Flex, Text } from 'rebass';
import { Input, Label } from '../../components/Form';
import Button from '../../components/Button/Button';
import PropTypes from 'prop-types';
import { IdArrayInput } from '../../hooks/useTablePages';

type TestAnniversaryModalProps = {
  onClose: () => void;
  selectedIds: IdArrayInput;
};

const SET_TEST_ANNIVERSARY = gql`
  mutation SetAssemblyTestAnniversary($assemblyIds: [ID!]!, $date: String!) {
    setAssemblyTestAnniversary(assemblyIds: $assemblyIds, date: $date) {
      id
      testAnniversary
      testAnniversaryMonth
      nextTestDate
    }
  }
`;

const TestAnniversaryModal: React.FC<TestAnniversaryModalProps> = ({
  onClose,
  selectedIds,
}) => {
  const [date, setDate] = useState<string>('');
  const [
    setTestAnniversary,
    { data, loading: mutationLoading, error: mutationError },
  ] = useMutation(SET_TEST_ANNIVERSARY, {
    onCompleted: onClose,
    onError: useCallback((error) => {
      console.error('Error setting assembly test anniversaries', error);
    }, []),
  });

  return (
    <Modal title="Set Test Anniversary" onClose={onClose}>
      <ModalBody>
        <Flex p={3} flexDirection="column">
          <Text pb={5} variant="body1">
            Set the anniversary date for {selectedIds.length} assemblies.
          </Text>
          <Label>Test Anniversary</Label>
          <Input
            type="date"
            value={date}
            onChange={(event) => {
              setDate(event.target.value);
            }}
            autoComplete="off"
          />
          {mutationLoading && <p>Loading...</p>}
          {mutationError && <p>Error :( {mutationError.message}</p>}
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          icon="save"
          onClick={() => {
            setTestAnniversary({
              variables: { assemblyIds: selectedIds, date },
            });
          }}
        >
          Save
        </Button>
        <Button variant="outline" icon="slash-circle" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

TestAnniversaryModal.propTypes = {
  onClose: PropTypes.any,
  selectedIds: PropTypes.any.isRequired,
};

export default TestAnniversaryModal;
